import SimpleQRCode from "../../../../../api/qr-code/SimpleQRCode";
import classes from "./QRCodeViewItem.module.css";
import {Group} from "@mantine/core";
import {ReactNode, useContext} from "react";
import QRCodeViewItemContext from "./QRCodeViewItemContext";
import SectionLeft from "./sections/left/SectionLeft";
import SectionRight from "./sections/right/SectionRight";
import QRCodeContext from "../../../../../contexts/qr-code/QRCodeContext";
import {useMediaQuery} from "@mantine/hooks";

type QRCodeViewItemProps = {
    /**
     * QR Code to render.
     * Declared SimpleQRCode.
     * @author Kacper Faber
     * @since 0.1.7
     */
    qrCode: SimpleQRCode;
}

/**
 * QRCodeViewItem to be displayed in QRCodeListView.
 * @author Kacper Faber
 * @since 0.1.7
 * @constructor
 */
function QRCodeViewItem(props: QRCodeViewItemProps) {
    const qrCtx = useContext(QRCodeContext);
    const isSmallScreen = useMediaQuery("(max-width: 1024px)");

    /**
     * Delete item in current context.
     * Reloads context if deleted successfully.
     * @Returns promise<void>
     * @author Kacper Faber
     * @since 0.1.9
     */
    const deleteItem = async () => {
        if (!props.qrCode.id) {
            throw new Error('Cannot delete this item, because it\'s undefined');
        }

        await qrCtx.deleteById(props.qrCode.id);
        qrCtx.reload();
    }

    /**
     * Wraps your children inside a QRCodeViewItemContext.
     * @author Kacper Faber
     * @since 0.1.8
     * @param children
     */
    const wrapContext = (children: ReactNode | ReactNode[]) => {
        return (
            <QRCodeViewItemContext.Provider
                children={children}
                value={{qrCode: props.qrCode, delete: deleteItem}}
            />
        );
    };

    return wrapContext(
        <div className={classes.root}>
            <Group w="100%" align="center" justify='space-between' wrap={isSmallScreen ? "wrap" : "nowrap"}>
                <SectionLeft/>
                <SectionRight/>
            </Group>
        </div>
    );
}

export default QRCodeViewItem;

// TODO: QRCodeViewItem.tsx
//  Improve the design
//  It's not responsive
//  Group with sections is nowrap